/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * grimoire/v1/api.proto
 * OpenAPI spec version: version not set
 */

/**
 * How an automation uses a collection, derived from the collection access
methods (get / insert / update / delete) recorded in its code manifest.
Any write access classifies the collection as WRITE (write subsumes read).

 - COLLECTION_USAGE_TYPE_UNSPECIFIED: Default; usage could not be determined.
 - COLLECTION_USAGE_TYPE_READ: Read-only accesses (e.g. get).
 - COLLECTION_USAGE_TYPE_WRITE: At least one write access (e.g. insert / update / delete).
 */
export type V1CollectionUsageType =
  (typeof V1CollectionUsageType)[keyof typeof V1CollectionUsageType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1CollectionUsageType = {
  COLLECTION_USAGE_TYPE_UNSPECIFIED: 'COLLECTION_USAGE_TYPE_UNSPECIFIED',
  COLLECTION_USAGE_TYPE_READ: 'COLLECTION_USAGE_TYPE_READ',
  COLLECTION_USAGE_TYPE_WRITE: 'COLLECTION_USAGE_TYPE_WRITE',
} as const;
